<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="close">
    <div class="modal-body">
      <div class="head-body">
        <div class="back" @click="back" v-if="gradeList.length > 0">
          <img src="../assets/ic_back.png" alt="" />
        </div>
        <div class="move-title">移动到“
        <label>{{ dir.title }}</label>  
        ”</div>
      </div>
      <div class="content">
        <div class="content-item" v-for="(item, index) in dir.subs" :key="index" @click="clickItem(item)">
          <div class="item-ic">
            <img src="../assets/type_dir.png" alt="" />
          </div>
          <div class="item-body">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="time">
              {{ item.createtime }}
            </div>
          </div>
        </div>
      </div>
      <div class="btns-body">
        <div class="btn clean" @click="close">取消</div>
        <div class="span"></div>
        <div class="btn success" @click="submit">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import { diskDirList, diskMove } from '@/utils/api/apis.js'
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      selectionFile: {
        type: Array
      }
    },
    data() {
      // 这里存放数据
      return {
        dir: {
          title: '根目录',
          subs: [],
          id: -1,
        },
        gradeList: [],
        tarageId: 0
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      isVisible(newValue) {
        if (newValue) {
          this.getDirList()
        }
      },
    },
    // 方法集合
    methods: {
      close() {
        this.tarageId = 0;
        this.$emit('update:isVisible', false);
      },
      async submit() {
        const ids = this.selectionFile.map(item => item.id).join(',');
        try{
          await diskMove({ids: ids, dir_id: this.tarageId})
          // this.$emit('cleanSelectedFiles')
          this.$emit('reloadFiles')
          this.$toast('移动成功');
          this.close()
        }catch(e){
          this.$toast(e)
          this.$errorLog('dir_list_dialog/submit', e)
        }
      },
      back() {
        this.dir = this.gradeList.pop()
        this.tarageId = this.dir.id;
      },
      clickItem(data) {
        this.gradeList.push({...this.dir});
        this.getDirList(data.id, data.title);
        this.tarageId = data.id
      },
      async getDirList(dirId = 0, name = '') {
        var excIds = [];
        this.selectionFile.forEach((item) => {
          if (item.is_dir == 1) {
            excIds.push(item.id)
          }
        })
        try{
          var base = await diskDirList({'dir_id': dirId, 'exc_id': excIds.join(',')});
          if (dirId == 0) {
            this.dir = {
              title: '根目录',
              subs: base.data,
              id: 0
            }
          } else {
            this.dir.id = dirId
            this.dir.title = name
            this.dir.subs = base.data
          }
        }catch(e){
          this.$toast(e)
          this.$errorLog('dir_list_dialog/getDirList', e)
        }
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(68,68,68, .2);
    .modal-body {
      width: 452px;
      height: 600px;
      background-color: white;
      border-radius: 14px;
      box-shadow: -10px 4px 7px 4px rgba(68,68,68, .2);
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      .head-body {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        font-size: 16px;
        font-weight: bold;
        position: relative;
        .back:hover {
          cursor: pointer;
        }
        .back {
          position: absolute;
          left: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          /* margin-right: 12px; */
          img {
            width: 24px;
            height: 24px;
          }
        }
        .move-title {
          display: flex;
          align-items: center;
          justify-content: center;
          label {
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .content {
        flex: 1;
        overflow-y: auto; /* 允许垂直滚动 */
        /* 隐藏滚动条 */
        &::-webkit-scrollbar {
          display: none;  /* 隐藏滚动条 */
        }
        .content-item:hover {
          cursor: pointer;
        }
        .content-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .item-ic {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            /* margin: 0 16px 0 22px; */
            margin-right: 16px;
            img {
              width: 32px;
              height: 32px;
              border-radius: 3px;
              object-fit: cover;
            }
          }
          .item-body {
            display: flex;
            flex-direction: column;
            font-size: 13px;
            .title {
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              /* 修改为最多显示两行 */
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
            }
            .time {
              font-size: 11px;
              color: #666;
            }
          }
        }
      }
      .btns-body {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 64px;
        .span {
          width: 12px;
        }
        .btn {
          flex: 1;
          height: 32px;
          background-color: rgba(0, 0, 0, 0.04);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          border-radius: 8px;
          font-weight: bold;
        }
        .btn:hover {
          cursor: pointer;
        }
        .success {
          background-color: rgba(74, 131, 255, 1);
          color: white;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dir_list_dialog.vue